(function() {
    'use strict';

    angular.module('core')
        .filter('unique', function() {
            return function(collection, keyname) {
                let output = [];
                let keys = [];
                angular.forEach(collection, function(item) {
                    const key = item[keyname];
                    if (keys.indexOf(key) === -1) {
                        keys.push(key);
                        output.push(item);
                    }
                });
                return output;
            };
        });
})();
